var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42661_1967)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_42661_1967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72917 2.0835C4.80869 2.0835 4.0625 2.82969 4.0625 3.75016V21.2502C4.0625 22.1706 4.80869 22.9168 5.72917 22.9168H19.2708C20.1913 22.9168 20.9375 22.1706 20.9375 21.2502V7.29183L15.7292 2.0835H5.72917Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_42661_1967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89575 12.2394C9.89575 11.7186 9.99992 11.3019 10.1041 11.0415C10.2083 10.7811 10.4166 10.5207 10.677 10.3123C10.9374 10.0519 11.1978 9.89567 11.5624 9.7915C11.8749 9.68734 12.1874 9.63525 12.552 9.63525C13.2812 9.63525 13.8541 9.84359 14.3749 10.2603C14.8437 10.6769 15.1041 11.1978 15.1041 11.8748C15.1041 12.1873 14.9999 12.4478 14.8958 12.7082C14.7916 12.9686 14.5312 13.2811 14.1145 13.6457C13.6978 14.0103 13.5416 14.2707 13.3853 14.4269C13.2291 14.5832 13.177 14.7915 13.0728 14.9998C12.9687 15.2082 13.0208 15.3644 13.0208 15.8853H11.9791C11.9791 15.3644 12.0312 15.104 12.0833 14.8436C12.1353 14.5832 12.2395 14.3748 12.3958 14.1665C12.552 13.9582 12.7083 13.6978 13.0728 13.3332C13.4374 12.9686 13.6978 12.7082 13.802 12.5519C13.9062 12.3957 14.0103 12.1353 14.0103 11.7707C14.0103 11.4061 13.8541 11.1457 13.5937 10.8853C13.3333 10.6248 12.9687 10.4686 12.4999 10.4686C11.4583 10.4686 10.9374 11.1978 10.9374 12.2394H9.89575ZM13.0208 17.9686H11.9791V16.9269H13.0208V17.9686Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4489 6.80322H16.2175L20.9376 11.5233V7.2915L20.4489 6.80322Z",
    fill: "url(#paint0_linear_42661_1967)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 7.2915L15.7292 2.08317C15.7292 4.95965 18.061 7.2915 20.9375 7.2915Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_42661_1967",
    x: 4.0625,
    y: 1.0835,
    width: 16.875,
    height: 22.8335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_42661_1967"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_42661_1967",
    result: "effect2_innerShadow_42661_1967"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_42661_1967",
    x: 8.89575,
    y: 8.63525,
    width: 14.2083,
    height: 19.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42661_1967"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_42661_1967",
    result: "effect2_dropShadow_42661_1967"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_42661_1967",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42661_1967",
    x1: 17.2755,
    y1: 5.74528,
    x2: 21.9955,
    y2: 10.4653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42661_1967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.70f4d7f0a2da4070c83067e320f6c2aa.svg";
export { ForwardRef as ReactComponent };